import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { StepsComponent } from './steps.component';
import { AppComponentsSharedModule } from '../app-components.shared.module';

@NgModule({
  imports: [
    JssModule.forChild(StepsComponent),
    AppComponentsSharedModule
  ],
  declarations: [
    StepsComponent
  ],
})
export class StepsModule { }
